export default price => price ? `$${(price).toLocaleString()}` : ''
